import axios from 'axios'
import { decode } from 'jsog'

const toData = response => decode(response.data)

export function upsertAnswer(data): Promise {
  return axios.post('/bw/answer', data).then(toData)
}

export function updateAnswer(data): Promise {
  return axios.put('/bw/answer/update', data).then(toData)
}

export function getComments(scanId): Promise {
  return axios.get(`/bw/answer/all/${scanId}`).then(toData)
}

export function getAnswers(scanId): Promise {
  return axios.get(`/bw/answer/${scanId}`).then(toData)
}



// WEBPACK FOOTER //
// ./src/services/answer-service.js